interface SetupConfiguration {
  accountID: string
  agentID: string
  licenseKey: string
  applicationID: string
}

const defaultInit = {
  distributed_tracing: {
    enabled: true,
    cors_use_newrelic_header: false,
    cors_use_tracecontext_headers: false
  },
  privacy: {
    cookies_enabled: true
  },
  ajax: {
    deny_list: ['bam.nr-data.net']
  }
}

const defaultLoaderConfig = {
  trustKey: '',
  agentID: '',
  licenseKey: '',
  applicationID: ''
}

const defaultInfo = {
  beacon: 'bam.nr-data.net',
  errorBeacon: 'bam.nr-data.net',
  licenseKey: '',
  applicationID: '',
  sa: 1
}

/**
 * Inicializa a configuração para o agente New Relic.
 *
 * @param {string} [appName='NREUM'] - O nome da Instância.
 * @param {SetupConfiguration} config - O objeto de configuração de instalação.
 */
export function setupConfig(appName = 'NREUM', config: SetupConfiguration) {
  window.nr = window.nr || {}
  window.nr[appName] = window.nr[appName] || {}
  window.nr[appName].init = defaultInit
  window.nr[appName].loader_config = { ...defaultLoaderConfig, ...config }
  window.nr[appName].info = { ...defaultInfo, ...config }
}
